import React from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";

// Register necessary chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function FlightBarchart() {
  // Generate dummy data for the last 15 days
  const labels = Array.from({ length: 15 }, (_, i) => {
    const date = new Date();
    date.setDate(date.getDate() - (14 - i));
    return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  });

  // Dummy data: Cash tickets booked for flights
  const cashBookings = Array.from({ length: 15 }, () => Math.floor(Math.random() * 50) + 10); // Random values between 10-60

  const data = {
    labels,
    datasets: [
      {
        label: "Cash Tickets Booking",
        data: cashBookings,
        backgroundColor: "#df0024",
        borderColor: "#df0024",
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { position: "top" },
      title: { display: true, text: "Cash Tickets Booking for Flights (Last 15 Days)" },
    },
    scales: {
      y: { beginAtZero: true },
    },
  };

  return (
    <div className="container my-2">
      <h2 className="text-center mb-4 font4">Flight Booking Stats</h2>
      <Bar data={data} options={options} />
    </div>
  );
}

export default FlightBarchart;
